import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function RmaPrint(body, name) {
    let bList = []
    let duesTotal = ['Summery', 0, 0, 0];
    let i = 0
    body.forEach(element => {
        const b = [
            element.date,
            element.warranty?"YES":"NO",
            element.repeat?"YES":"NO",
            element.delivered?"YES":"NO",
            printFormatNumber(element.bookId.toString()),
            `${(element.customer.trim().substring(0,10))}`,
            `${element.description.trim().substring(0,10)}`,
            `${element.technician.trim().substring(0,10)}`,
            element.completionDate,
            `${element.diagnostic.trim().substring(0,10)}`,
            printFormatNumber(element.quantity.toString()),
            printFormatNumber(element.expenses.toString()),
            printFormatNumber(element.charges.toString()),
            element.completionDate,
            element.deliveryDate,
            printFormatNumber(element.repeatCount.toString()),
            `${element.comment.trim().substring(0,10)}`
    ]

        bList = [...bList, b]
    })
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: "a4",
    });
    const heading = ['Date', 'W', 'R', 'D', 'Book', "Customer", 'Description', "Technician", "Completion",'Diagnostic', 'Qnty', "Exp", 'Charges', 'DF', "DD", "RC", "Comment"];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Dues Report", 300, 40)
    doc.text(`Date:${ToBritishDate(new Date())}`, 300, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
   //         footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 6, cellWidth: "auto"},
 //           showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),

            columnStyles: {
                0: {halign: "Left"},
                1: {halign: "center"},
                2: {halign: "center"},
                3: {halign: "center"},
                4: {halign: "right"},
                5: {halign: "Left"},
                6: {halign: "Left"},
                7: {halign: "Left"},
                8: {halign: "left"},
                9: {halign: "right"},
                10: {halign: "right"},
                11: {halign: "right"},
                12: {halign: "left"},
                13: {halign: "left"},
                14: {halign: "Left"},
                15: {halign: "Left"},
            },
        }
    )
    doc.save(`RMA-${ToBritishDate(new Date())}.pdf`);
}



